import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { PermissionService } from './permission.service';

// TODO meter tip de abrir book, de descargar estudio, de compartir y de ver histórico
export enum TIPS_STEPS {
  NONE = -1,
  BOOK_OPEN_VISOR = 1,
  CAN_OPEN_STUDIES = 2,
  COMP_MAMO = 3,
}

export namespace TIPS_STEPS {
  export function string2Step(st: string) {
    switch (st.toLowerCase()) {
      case 'none':
        return TIPS_STEPS.NONE;
      case 'book_open_visor':
        return TIPS_STEPS.BOOK_OPEN_VISOR;
      case 'can_open_studies':
        return TIPS_STEPS.CAN_OPEN_STUDIES;
      case 'comp_mamo':
        return TIPS_STEPS.COMP_MAMO;
    }
    return undefined;
  }

  export function strings2Steps(sts: string[]) {
    return sts.map(st => string2Step(st));
  }
}

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  currentStep: TIPS_STEPS | undefined = TIPS_STEPS.NONE;
  get currentStepIndex() {
    return this.stepsToShow.findIndex(s => s == this.currentStep);
  }
  get hasNext() {
    return this.currentStepIndex < this.stepsToShow.length - 1
  }
  get hasPrev() {
    return this.currentStepIndex > 0
  }

  stepsToShow: (TIPS_STEPS | undefined)[] = []

  constructor(
    private permissionService: PermissionService,
    private configService: ConfigService
  ) { }

  open(steps: (TIPS_STEPS | undefined)[]) {
    if (steps == null || steps.length == 0) return;
    this.currentStep = steps[0];
    if (steps.length > 1) {
      this.stepsToShow = steps;
    }
  }

  onNext() {
    this.currentStep = this.stepsToShow[this.currentStepIndex + 1]
  }

  onPrev() {
    this.currentStep = this.stepsToShow[this.currentStepIndex - 1]
  }

  onClose() {
    this.currentStep = TIPS_STEPS.NONE;
    this.stepsToShow = [];
  }

  public showHelp() {
    this.configService.getConfig().then(c => {
        this.open(TIPS_STEPS.strings2Steps(c.patient_tips));
    })

  }
}
